import intl from "react-intl-universal";
import { Link, useLocation } from "react-router-dom";
import { ListItemIcon, ListItemText, Box } from "@mui/material";
import { TbChevronLeft, TbHome, TbPlus } from "react-icons/tb";
import { Container, MenuItem, Menu } from "../../../../Components/Molecules/MenuNavigation/styles";
import { useAuth } from "../../../../Contexts/AuthContext";
import { useBaasInstance } from "../../../../Contexts/BaasInstanceContext";
import { useBaasPlatformCreateAccess } from "../../../../Hooks/useBaasPlatformCreateAccess";
import { BAAS_BASE_PATH, BAAS_INSTANCE_CREATE_PATH, BAAS_ORG_ADMIN_NAV_ITEMS } from "../constants";

const listItemTextSx = { m: 0 };

const sectionHeaderSx = {
  px: 1.5,
  pt: 1.5,
  pb: 0.5,
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "#9ca3af",
};

const isAdminItemActive = (pathname, item) =>
  pathname === item.path || pathname.startsWith(`${item.path}/`);

export const BaasInstancesSidebar = ({ onNavigate }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { clearSelectedInstance } = useBaasInstance();
  const { canCreateInstance, isValutConfigAdmin } = useBaasPlatformCreateAccess();
  const canAccessCarteira = user.canAccessCarteira !== false;
  // Org Usuários/Grupos = Valut matrix only. Create CTA = matrix or client multi-instance.
  // During view-as, isValutConfigAdmin is suppressed so clients' nav is simulated.
  const showPlatformAdminNav = isValutConfigAdmin;
  const showCreateNav = canCreateInstance;

  const isHomeActive =
    location.pathname === BAAS_BASE_PATH || location.pathname === `${BAAS_BASE_PATH}/`;
  const isCreateActive = location.pathname === BAAS_INSTANCE_CREATE_PATH;

  const handleLandingNav = () => {
    clearSelectedInstance();
    onNavigate?.();
  };

  return (
    <Container
      aria-label={intl.get("baas.instances.sidebarLabel")}
      style={{ height: "100%", minHeight: "100%" }}
    >
      <Box
        sx={{
          px: 1.5,
          pt: 0.5,
          pb: 1,
          flexShrink: 0,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "#9ca3af",
        }}
      >
        {intl.get("nav.baas")}
      </Box>

      <Menu>
        <Link to={BAAS_BASE_PATH} className="link-no-zoom" onClick={handleLandingNav}>
          <MenuItem $isSelected={isHomeActive} selected={false} disableRipple>
            <ListItemIcon sx={{ minWidth: 28, mr: 0.5, color: "inherit" }}>
              <TbHome size={18} />
            </ListItemIcon>
            <ListItemText
              sx={listItemTextSx}
              primary={
                intl.get("baas.instances.sidebar.home") ||
                intl.get("baas.nav.home")
              }
              primaryTypographyProps={{
                fontSize: 14,
                fontWeight: isHomeActive ? 600 : 500,
                lineHeight: 1.25,
                noWrap: true,
              }}
            />
          </MenuItem>
        </Link>

        {showCreateNav ? (
          <Link
            to={BAAS_INSTANCE_CREATE_PATH}
            className="link-no-zoom"
            onClick={handleLandingNav}
          >
            <MenuItem $isSelected={isCreateActive} selected={false} disableRipple>
              <ListItemIcon sx={{ minWidth: 28, mr: 0.5, color: "inherit" }}>
                <TbPlus size={18} />
              </ListItemIcon>
              <ListItemText
                sx={listItemTextSx}
                primary={intl.get("baas.instances.sidebar.create")}
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: isCreateActive ? 600 : 500,
                  lineHeight: 1.25,
                  noWrap: true,
                }}
              />
            </MenuItem>
          </Link>
        ) : null}

        {showPlatformAdminNav ? (
          <>
            <Box sx={sectionHeaderSx}>{intl.get("baas.admin.section")}</Box>

            {BAAS_ORG_ADMIN_NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              const isSelected = isAdminItemActive(location.pathname, item);
              const label = intl.get(item.labelKey);

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className="link-no-zoom"
                  onClick={handleLandingNav}
                >
                  <MenuItem $isSelected={isSelected} selected={false} disableRipple>
                    <ListItemIcon sx={{ minWidth: 28, mr: 0.5, color: "inherit" }}>
                      <Icon size={18} />
                    </ListItemIcon>
                    <ListItemText
                      sx={listItemTextSx}
                      primary={label}
                      primaryTypographyProps={{
                        fontSize: 14,
                        fontWeight: isSelected ? 600 : 500,
                        lineHeight: 1.25,
                        noWrap: true,
                      }}
                    />
                  </MenuItem>
                </Link>
              );
            })}
          </>
        ) : null}
      </Menu>

      <Box sx={{ flex: 1, minHeight: 8 }} aria-hidden />

      {canAccessCarteira ? (
        <Box
          sx={{
            flexShrink: 0,
            pt: 1,
            borderTop: (theme) =>
              theme.palette.mode === "dark"
                ? "1px solid #262626"
                : "1px solid #e5e7eb",
          }}
        >
          <Link to="/" className="link-no-zoom" onClick={onNavigate}>
            <MenuItem $isSelected={false} selected={false} disableRipple>
              <ListItemIcon sx={{ minWidth: 28, mr: 0.5, color: "inherit" }}>
                <TbChevronLeft size={18} />
              </ListItemIcon>
              <ListItemText
                sx={listItemTextSx}
                primary={intl.get("baas.nav.backToApp")}
                primaryTypographyProps={{
                  fontSize: 13,
                  fontWeight: 500,
                  lineHeight: 1.25,
                  noWrap: true,
                }}
              />
            </MenuItem>
          </Link>
        </Box>
      ) : null}
    </Container>
  );
};
